import { useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { useLanguage } from "../../../Translations/LenguageContext";
import MandatorySign from "../../../Components/MandatorySign";
import { MdOutlineCheckCircle, MdOutlineCircle } from "react-icons/md";
import ErrorMessage from "../../../Components/ErrorMessage";
import Spinner from "../../../Components/Spinner";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const NewGeoTopicModal = ({
    account_id,
    org_id,
    geo_id,
    show,
    handleClose,
    columns,
    selectedContexts,
    getTopics
}) => {
    const { t } = useLanguage()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    const [formData, setFormData] = useState({
        intent_type: "",
        name: "",
        description: "",
    });

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSave = async () => {
        if (!formData.intent_type.trim()) {
            setErrorMessage({ message: t.geo.intent_type_required, display: true });
            return;
        }

        if (!formData.name.trim()) {
            setErrorMessage({ message: t.geo.intent_name_required, display: true });
            return;
        }

        if (!formData.description.trim()) {
            setErrorMessage({ message: t.geo.intent_desc_required, display: true });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/new_custom_geo_topic`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    geo_id,
                    context_id: selectedContexts[0],
                    name: formData.name,
                    description: formData.description,
                    intent_type: formData.intent_type,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if (data.message == "OK") {
                getTopics()
                closeModal()
            }

        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingSave(false);
        }
    };

    const closeModal = () => {
        setFormData({
            intent_type: "",
            name: "",
            description: "",
        })

        setLoadingSave(false);
        setErrorMessage({ message: "", display: false });
        handleClose()
    }

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{t.geo.new_topic}</p>
            </div>
            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">
                    <label className="input_label">{t.geo.intent_type} <MandatorySign message={t.mandatory_field} /></label>
                    <Dropdown>
                        <Dropdown.Toggle
                            as="div"
                            className="register_form_first fade-in"
                        >
                            {formData.intent_type ? t.geo[formData.intent_type] : t.geo.select_intent_type}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="custom_dropdown_menu">
                            <div className="dropdown_container fade-in">
                                {columns.map((column, index) => (
                                    column.map(({ intent, topics }) => (
                                        <button
                                            key={intent}
                                            onClick={() =>
                                                setFormData(prev => ({
                                                    ...prev,
                                                    intent_type: intent
                                                }))
                                            } className="settings_link"
                                        >
                                            <i >
                                                {formData.intent_type == intent
                                                    ? <MdOutlineCheckCircle />
                                                    : <MdOutlineCircle />}
                                            </i>
                                            {t.geo[intent]}
                                        </button>
                                    ))
                                ))}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>

                    <div className="label_input">
                        <label className="input_label">{t.geo.topic} <MandatorySign message={t.mandatory_field} /></label>
                        <input
                            type="text"
                            name="name"
                            maxLength={100}
                            value={formData.name}
                            onChange={handleChange}
                            placeholder={t.geo.topic_name_placeholder}
                            className="register_form_first fade-in"
                            autoComplete="off"
                        />
                    </div>

                    <div className="label_input">
                        <label className="input_label">
                            {t.description} <MandatorySign message={t.mandatory_field} />
                        </label>
                        <textarea
                            name="description"
                            maxLength={300}
                            value={formData.description}
                            onChange={handleChange}
                            placeholder={t.geo.topic_description_placeholder}
                            className="register_form_first textarea_reg fade-in"
                            autoComplete="off"
                        />
                    </div>
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleSave}
                        disabled={loadingSave}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.save}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default NewGeoTopicModal;